<template>
  <div class="GlobalFormDemo">
    <GlobalForm :init-data="initData" :form-rules="formRules" :form-item-list="formItemList" :inline="true" round :needBtnLoading="true"
      @handleConfirm="handleConfirm" confirmBtnName="查询">
      <el-form-item class="el_from" v-if="staffType == '01'" label="所属区域" label-width="68px" slot="areaName"
        style="margin:0">
        <el-select v-model="areaName" placeholder="请选择区域" filterable clearable>
          <el-option v-for="item in areagetAreaSelect" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="el_from" label="门店标签" label-width="75px" slot="areaName"
        style="margin:0">
        <el-select v-model="tagId" placeholder="请选择门店标签" filterable clearable>
          <el-option v-for="item in tagSelect" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="el_from" v-if="isOpenBuyNiceMachine" label="是否启用靓机自收" label-width="125px" slot="isOpenSelfBuyNiceMachine"
        style="margin:0">
        <el-select v-model="isOpenSelfBuyNiceMachine" placeholder="请选择" filterable clearable>
          <el-option v-for="item in NiceMachineoption" :key="item.label" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <div style="text-align: right; margin-bottom: 20px" slot="AddSlot">
        <el-button size="small" type="warning" icon="el-icon-plus" @click="report()">批量导入</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleBtn('add')">添加门店</el-button>
        <el-button size="small" type="success" icon="el-icon-download" :loading="exportLoading" @click="exportTable()">导出当前数据</el-button>
        <el-button size="small" v-if="isOpenBuyNiceMachine" type="danger" @click="machineSelf()">靓机自收额度设置</el-button>
      </div>
    </GlobalForm>
    <el-dialog class="add-dialog" title="导入门店" :visible.sync="dialogVisible" :close-on-click-modal="false" width="500px"
      @closed="handleDialogClosed">
      <div class="step">
        <div class="step-title">
          <img src="@/assets/images/ico_ts_red.png" alt="" style="width: 18px; height: 18px; margin-right: 5px" />
          <span>温馨提示:请按模板表格严格填写，带*的为必填项。</span>
        </div>
        <div class="step-content">
          <el-button type="success" icon="el-icon-download" size="medium" @click="download">下载数据模板</el-button>
        </div>
        <el-form ref="importForm" :model="importForm" :rules="importRules" label-width="80px">
          <el-form-item label="表格上传" prop="fileName" class="fileName">
            <el-input v-model="importForm.fileName" @clear="fileClear" :disabled="true" size="medium" clearable>
            </el-input>
            <div style="float: right; position: relative">
              <el-button size="medium" type="warning" icon="el-icon-upload2">上传表格</el-button>
              <input accept=".xls, .xlsx" ref="fileUpload" @change="onUploadList" type="file" style="
                  opacity: 0;
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  cursor: pointer;
                " />
            </div>
            <div style="color: #ff687b">
              仅支持.xls及.xlsx格式,单次上传大小不超过5M
            </div>
          </el-form-item>
        </el-form>
        <div class="step2-content"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click.native="uploadFile">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog class="add-dialog" title="设置额度" :visible.sync="setlimitVisible" :close-on-click-modal="false"
      width="1000px" @closed="setDialogClosed">
      <GlobalForm ref="orderForm" :init-data="setliData" :form-rules="formRules" :form-item-list="formItemList"
        :inline="true" round @handleConfirm="serchConfirm" confirmBtnName="查询">
        <el-form-item class="el_from" v-if="staffType == '01'" label="所属区域" label-width="68px" slot="areaName"
          style="margin:0">
          <el-select v-model="limitareaName" placeholder="请选择区域" filterable clearable>
            <el-option v-for="item in areagetAreaSelect" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="el_from" v-if="isOpenBuyNiceMachine" label="是否启用靓机自收" label-width="125px" slot="isOpenSelfBuyNiceMachine"
        style="margin:0">
        <el-select v-model="isOpenNiceMachine" placeholder="请选择" filterable clearable>
          <el-option v-for="item in NiceMachineoption" :key="item.label" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      </GlobalForm>
      <div class="set_endu">
        <p>门店列表</p>
        <el-button size="small" :disabled="!selectLimitData.length" @click="updataLimit('all')"
          type="danger">批量修改额度</el-button>
      </div>
      <div style="margin-bottom: 20px;">
        <GlobalTable ref="GlobalTable" :isSelection="true" :isPagination="false" v-loading="loading"
          :columns="tableColumns" :data="seachDataList" :maxHeight="600" @handleSelect="handleSelect">
          <el-table-column label="店长" slot="storeMana" align="center">
            <template slot-scope="{ row }">
              <span v-if="row.storeManager" style="color:#0981FF;">{{
                row.storeManager
              }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="联系电话" slot="phone" align="center">
            <template slot-scope="{ row }">
              <span v-if="row.storeManagerPhone" style="color:#0981FF;">{{
                row.storeManagerPhone
              }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="是否开启靓机自收" slot="operationSex" align="center">
            <template slot-scope="{ row }">
              <p>{{ row.isOpenSelfBuyNiceMachine ? '是' : '否' }}</p>
            </template>
          </el-table-column>
          <el-table-column label="每日自收靓机总额度（元）" slot="selfBuyNiceMachineEveryDayMax" align="center">
            <template slot-scope="{ row }">
              <p>{{ row.selfBuyNiceMachineEveryDayMax == null ? '--' : row.selfBuyNiceMachineEveryDayMax }}</p>
            </template>
          </el-table-column>
          <el-table-column label="单笔自收靓机额度（元）" slot="selfBuyNiceMachineEveryTimeMax" align="center">
            <template slot-scope="{ row }">
              <p>{{ row.selfBuyNiceMachineEveryTimeMax == null ? '--' : row.selfBuyNiceMachineEveryTimeMax }}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" slot="operation" align="center">
            <template slot-scope="{ row }">
              <el-button @click="updataLimit('one', row)" size="small" type="danger">修改额度</el-button>
            </template>
          </el-table-column>
        </GlobalTable>
      </div>
    </el-dialog>
    <el-dialog class="add-dialog" title="修改额度" :visible.sync="updatelimitVisible" :close-on-click-modal="false"
      width="500px" @closed="updatelimitDialogClosed">
      <p>选择门店：已选择{{ upataType == 'all' ? selectLimitData.length : 1 }}个商家</p>
      <div class="limit_style">
        <span>单笔自收靓机额度：</span>
        <el-col :span="11">
          <el-input v-model.trim="onceNum" oninput="this.value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入正整数"></el-input>
        </el-col>
        <span style="margin-left: 5px;">元</span>
      </div>
      <div class="limit_style">
        <span>每日累计自收靓机额度：</span>
        <el-col :span="11">
          <el-input v-model.trim="alldayNum" oninput="this.value=value.replace(/[^0-9]/g,'')"
            placeholder="请输入正整数"></el-input>
        </el-col>
        <span style="margin-left: 5px;">元</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updatelimitVisible = false">取消</el-button>
        <el-button type="primary" @click.native="upataeSure">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { formValidateMobile } from "@/utils/form-validate";
import _api from "@/utils/request";
export default {
  name: "Form",
  props:{
    isOpenBuyNiceMachine:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      limitnumData:{},
      upataType: "",
      onceNum: "",
      alldayNum: "",
      seachDataList: [],
      selectLimitData: [],
      loading: false,
      setlimitVisible: false,
      updatelimitVisible: false,
      isOpenSelfBuyNiceMachine:null,
      isOpenNiceMachine:null,
      NiceMachineoption: [
            {
              value: true,
              label: "是",
            },
            {
              value: false,
              label: "否",
            },
          ],
      tableColumns: [
        { label: "门店名称", prop: "storeName" },
        { slotName: "storeMana" },
        { slotName: "phone" },
        { slotName: "operationSex" },
        { slotName: "selfBuyNiceMachineEveryDayMax" },
        { slotName: "selfBuyNiceMachineEveryTimeMax" },
        // { label: "每日自收靓机总额度（元）", prop: "selfBuyNiceMachineEveryDayMax" },
        // { label: "单笔自收靓机额度（元）", prop: "selfBuyNiceMachineEveryTimeMax" },
        { slotName: "operation" },
      ],
      areaName: '',
      tagId: "",
      limitareaName: '',
      areagetAreaSelect: [],
      // 导入弹窗
      dialogVisible: false,
      seachParams: {},
      importForm: {
        fileName: "",
      },
      importRules: {
        fileName: [
          {
            required: true,
            message: "仅支持.xls及.xlsx格式,单次上传大小不超过5M",
            trigger: "blur",
          },
        ],
      },
      paramsExcel: {},
      roleId: "",
      initData: null,
      setliData: null,
      formItemList: [
        { slotName: "areaName" },
        {
          key: "storeName",
          type: "input",
          labelName: "门店名称",
          placeholder: "请输入门店名称",
          lableWidth: '68px'

        },
        {
          key: "storeManager",
          type: "input",
          labelName: "店长",
          placeholder: "请输入店长名称",
          lableWidth: '40px'

        },
        {
          key: "staffMobile",
          type: "input",
          labelName: "联系电话",
          placeholder: "请输入联系电话",
          lableWidth: '68px'

        },
        { slotName: "isOpenSelfBuyNiceMachine" },
        // {
        //   key: "isOpenSelfBuyNiceMachine",
        //   type: "select",
        //   lableWidth: "125px",
        //   labelName: "是否启用靓机自收",
        //   option: [
        //     {
        //       value: true,
        //       label: "是",
        //     },
        //     {
        //       value: false,
        //       label: "否",
        //     },
        //   ],
        // },
        { slot: "AddSlot" },
      ],
      formRules: {
        mobile: [
          {
            validator: formValidateMobile,
            trigger: "blur",
          },
        ],
      },
      exportLoading: false,
      tagSelect: []
    };
  },
  created() {
    this.staffType = JSON.parse(localStorage.getItem('user')).staffType
    _api.areagetAreaSelect({ scope: '02' }).then(res => {
      this.areagetAreaSelect = res.data
    })
    _api.getStoreTagSelect().then(res => {
      this.tagSelect = res.data
    })
    this.handleConfirm()
    // this.serchConfirm()
  },
  watch: {
    importForm(newVal) {
      console.log(newVal, "importForm");
      if (!this.importForm.fileName) {
        this.paramsExcel.file = "";
      }
    },
  },
  methods: {
    //批量-靓机自收额度设置
    upataeSure() {
      const selflimitprams = {
        "selfBuyNiceMachineEveryDayMax": this.alldayNum,
        "selfBuyNiceMachineEveryTimeMax": this.onceNum,
        "storeIds": []
      }
      if(this.upataType=='all'){
        selflimitprams.storeIds=this.selectLimitData.map(item=>item.id)
      }else{
        selflimitprams.storeIds.push(this.limitnumData.id)
      }
      _api.saveBachSelfBuyNiceConfig(selflimitprams).then(res => {
        if(res.code===1){
          this.updatelimitVisible = false
          this.$refs.orderForm.$refs.validForm.resetFields();
          this.serchConfirm()
          this.selectLimitData=[]
          this.alldayNum=''
          this.onceNum=''
        }
      })
    },
    updatelimitDialogClosed() {
      this.alldayNum=''
        this.onceNum=''
      this.updatelimitVisible = false
    },
    updataLimit(type, data) {
      console.log(type, data);
      this.limitnumData=data
      this.upataType = type
      this.updatelimitVisible = true
    },
    handleSelect(e) {
      console.log(e);
      this.selectLimitData = e
    },
    //查询
    serchConfirm(data) {
      const SeachParams = {
        isOpenSelfBuyNiceMachine: this.isOpenNiceMachine,
        storeName: data && data.storeName ? data.storeName : "",
        storeManager: data && data.storeManager ? data.storeManager : "",
        storeManagerPhone: data && data.staffMobile ? data.staffMobile : "",
        pageNum: 1,
        pageSize: 9999999,
        areaId: this.limitareaName
      };
      _api.StaffManageList(SeachParams).then((res) => {
        if (res.code === 1) {
          console.log(res);
          this.seachDataList = res.data.records;
        }
      });
    },
    handleChange(val) {
      this.roleId = val;
    },
    report() {
      this.dialogVisible = true;
    },
    handleBtn() {
      this.$store.commit("tagsView/STORE_ADDEDIT", "add");
    },
    //查询
    handleConfirm(data,cd) {
      const SeachParams = {
        isOpenSelfBuyNiceMachine: this.isOpenSelfBuyNiceMachine,
        storeName: data && data.storeName ? data.storeName : "",
        storeManager: data && data.storeManager ? data.storeManager : "",
        staffMobile: data && data.staffMobile ? data.staffMobile : "",
        pageNum: 1,
        pageSize: 10,
        areaId: this.areaName,
        tagId: this.tagId,
        disuseLoding: () => {
          if (typeof cd === 'function') {
            cd()
          }
        },
      };
      this.seachParams = SeachParams;
      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
    setDialogClosed() {
      this.$nextTick(() => {
        this.setliData = null
        this.$refs.orderForm.$refs.validForm.resetFields();
      });
      this.limitareaName = ""
    },
    // 弹窗关闭
    handleDialogClosed() {
      if (this.$refs["addForm"]) {
        this.$refs["addForm"].resetFields();
      } else {
        this.$refs["importForm"].resetFields();
      }
      this.importForm = {
        fileName: "",
      };
      this.staffForm = {
        staffName: "",
        staffMobile: "",
        roleId: "",
        xcxStaffId: "",
        userAcc: "",
        userPwd: "",
        staffType: "",
      };
      this.$refs.fileUpload.value = "";
      this.paramsExcel = {};
      this.dialogVisible = false;
    },
    download() {
      const link = document.createElement("a");
      link.href = "/static/导入门店模板.xlsx";
      link.setAttribute("download", "导入门店模板.xlsx");
      document.body.appendChild(link);
      link.click();
    },
    onUploadList(event, type) {
      console.log(event);
      this.paramsExcel.file = event.target.files;
      if (this.paramsExcel.file.length) {
        this.paramsExcel.excelName = event.target.files[0].name;
        this.importForm.fileName = event.target.files[0].name;
      }
    },
    // 确定导出
    uploadFile() {
      if (!this.paramsExcel.file || this.paramsExcel.file.length == 0) {
        return this.$message.error("请上传表格");
      }
      const fd = new FormData();
      console.log(this.paramsExcel);
      fd.append("file", this.paramsExcel.file[0]); //文件
      console.log(fd);
      // 发起请求
      _api
        .inputStore(fd)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 1) {
            this.$store.commit("tagsView/STORE_EXCEL", "storeExcel");
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.importForm.fileName = "";
            this.$refs.fileUpload.value = "";
            this.dialogVisible = false;
          } else {
            this.$message({
              type: "warning",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.importForm.fileName = "";
          this.$refs.fileUpload.value = "";
        });
    },
    fileClear() {
      this.$refs.fileUpload.value = "";
      this.paramsExcel = {};
    },
    exportTable() {
      this.exportLoading = true
      _api.exportStore(this.seachParams).then((res) => {
        console.log(res);
        const content = res;
        const blob = new Blob([content]);
        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => {
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              this.$message.error(data.msg || "服务异常");
            }
          } catch (err) {
            const fileName = "门店列表.xlsx";
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
          }
        });
        reader.readAsText(blob, "utf-8");
      }).finally(() => {
            this.exportLoading = false;
          });
    },
    machineSelf() {
      this.setlimitVisible = true
      this.serchConfirm()
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {
  .step {
    .step-title {
      display: flex;
      color: #ff687b;
      margin-bottom: 18px;
    }

    .fileName {
      /deep/.el-input {
        width: 260px;
      }
    }

    .step-content {
      margin-bottom: 20px;
    }
  }
}

.set_endu {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.limit_style {
  margin-top: 20px;
  display: flex;
  align-items: center;
}
</style>
